module.exports = __webpack_public_path__ + "static/media/three-dots.4d75a859.svg";